import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-message-recepients',
  templateUrl: './message-recepients.component.html',
  styleUrls: ['./message-recepients.component.scss']
})
export class MessageRecepientsComponent implements OnInit {


  tableControls: any = { data: [] };
  currLang;
  constructor(
    private translate: TranslateService,
    private globalService: GlobalService,
    public dialogRef: MatDialogRef<MessageRecepientsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.data = this.data.map(element => ({
      name: element.name,
      national_id: element.national_id,
      role: element.roles[0].name
    }));
    this.setTableData();
  }


  ngOnInit(): void {
  }

  ngOnChanges() {
    this.setTableData();
  }

  // display-only: the raw backend role value is not modified
  getRoleLabel(role: string): string {
    if (!role) { return role; }
    const key = `roles.${role}`;
    const translated = this.translate.instant(key);
    return translated !== key ? translated : role;
  }

  setTableData() {
    this.translate.onLangChange.subscribe(param => {
      this.tableData();
    });
    this.translate.get('init').subscribe(param => {
      this.tableData();
    })
  }
  tableData() {
    this.tableControls = {
      selection: false,
      paging: false,
      view: "compact",
      columns: [
        {
          name: this.translate.instant('messages.username'),
          sort: false,
          type: "string",
          source: "name"
        },
        {
          name: this.translate.instant('messages.national-id'),
          sort: false,
          type: "string",
          source: "national_id"
        }, {
          name: this.translate.instant('messages.role'),
          sort: false,
          type: "string",
          source: "role",
          translateRole: true
        }
      ],
      data: this.data
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
